// Unpublished Work © 2021-2022 Deere & Company

import t from 'tcomb';
import {Search} from './search';
import {Profile} from './profile';
import {SelectBusinessContact} from './select-business-contact';
import {AddCustomer} from './add-customer';

export const Features = t.struct({
    addCustomer: AddCustomer,
    profile: Profile,
    search: Search,
    selectBusinessContact: SelectBusinessContact
}, {
    defaultProps: {
        addCustomer: AddCustomer({}),
        profile: Profile({}),
        search: Search({}),
        selectBusinessContact: SelectBusinessContact({})
    },
    name: 'Features',
    strict: true
});
